/**
 * CSV for report downloads (DESIGN_SYSTEM.md §13): made in the browser from data already on screen, never from a link that
 * carries a token. Numbers stay plain numbers (a dot for decimals) so spreadsheets read them as numbers; text that a
 * spreadsheet would run as a formula starts with `'` (OWASP CSV injection).
 */
export type CsvCell = string | number | boolean | null | undefined;

const FORMULA = /^[=+\-@\t\r]/;

function cell(value: CsvCell): string {
  if (value == null) return '';
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : '';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  const text = FORMULA.test(value) ? `'${value}` : value;
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Rows to CSV text, with a byte order mark so spreadsheets read Vietnamese as UTF-8. */
export function toCsv(rows: readonly (readonly CsvCell[])[]): string {
  return '﻿' + rows.map((row) => row.map(cell).join(',')).join('\r\n') + '\r\n';
}

/** Saves rows as a CSV file. */
export function downloadCsv(fileName: string, rows: readonly (readonly CsvCell[])[]) {
  const url = URL.createObjectURL(new Blob([toCsv(rows)], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
